import styled from 'styled-components';

export const ContainerButtonPanel = styled.div``;
